import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCookieConfig,
  setModalOpen,
  setPreferenceCenterOpen
} from '@/redux/cookieSlice';

export const ListsyncCookieSetting = () => {
  const cookie = useSelector((state: any) => state.cookie);
  const dispatch = useDispatch();
  const style = {
    p: 4
  };
  return (
    <Modal
      open={cookie.open}
      onClose={() => dispatch(setModalOpen(false))}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: { xs: '100%', lg: '500px' },
          bottom: { xs: '0', lg: '40px' },
          right: { xs: '0', lg: '40px' },
          left: { xs: '0', lg: 'auto' },
          border: { xs: 'none', lg: '1px solid #e2e8f0' },
          borderRadius: { xs: '24px 24px 0 0', lg: '16px' }
        }}
        className="absolute bg-white outline-none"
      >
        <IoClose
          onClick={() => dispatch(setModalOpen(false))}
          className="absolute right-4 top-4 cursor-pointer text-2xl text-[#64748b]"
        />
        <Typography
          id="modal-modal-title"
          className="text-center font-bold text-[#1a1a1a] lg:text-left"
          sx={{
            fontSize: { xs: '20px', lg: '24px' },
            px: { xs: 2, lg: 0 },
            mt: { xs: 4, lg: 0 },
            mb: 2
          }}
        >
          Select your cookie preferences
        </Typography>
        <Typography
          id="modal-modal-description"
          className="text-center !leading-7 !tracking-wide text-[#334155] lg:text-left"
          sx={{
            fontSize: { xs: '14px', lg: '16px' },
            px: { xs: 2, lg: 0 }
          }}
        >
          {`We use cookies to enhance your browsing experience, serve personalised
          ads or content, and analyse our traffic. By clicking "Accept All", you
          consent to our use of cookies.`}
        </Typography>
        <div className="mt-6 flex flex-col gap-3 lg:gap-4 px-0 lg:px-4">
          <button
            className="flex h-[50px] w-full items-center justify-center rounded-full lg:rounded-2xl text-white font-semibold transition-all duration-200"
            style={{
              background: '#3B82F6',
              boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.5)'
            }}
            onClick={() => dispatch(setCookieConfig('' as any))}
          >
            Accept All
          </button>
          <button
            className="hidden lg:flex h-[50px] w-full items-center justify-center rounded-2xl border-2 border-[#e2e8f0] bg-white text-[#334155] font-semibold transition-all duration-200 hover:bg-[#f8fafc]"
            onClick={() => dispatch(setCookieConfig('' as any))}
          >
            Reject All
          </button>
          <button
            className="flex h-[50px] w-full items-center justify-center rounded-full lg:rounded-2xl border border-[#3B82F6] bg-white text-[#3B82F6] font-semibold transition-all duration-200"
            onClick={() => dispatch(setPreferenceCenterOpen(true))}
          >
            Customise
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ListsyncCookieSetting;
